import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n.js'; // initialized i18next instance using reactI18nextModule
import './analytics.js';
import '../node_modules/chartjs-plugin-datalabels';

import AppContent from './modules/main/AppContent.js';
import store from './state/store.js'
import LocationWatcher from './modules/misc/LocationWatcher.js';
import DatabaseService from './services/DatabaseService.js';
import Utils from 'utils/Utils.js';

import LICENSES from './licenses.json';


/* FOR DEBUG - remove in production */
import _ from 'underscore';
import moment from 'moment';
import ChallengeService from './services/ChallengeService.js'
import UserService from './services/UserService.js'
window.dev = {};
window.dev.store = store;
window.dev.ChallengeService = ChallengeService;
window.dev.DatabaseService = DatabaseService;
window.dev.UserService = UserService;
window.dev._ = _;
window.dev.moment = moment;
window.dev.Utils = Utils;
/* */



DatabaseService.setTranslator(i18n);


class App extends Component {
    componentDidMount() {
        window.branch.init('key_live_hjEIZL8DQGpP3GBZXzaxXgdiAwh0v9v4');          
    }

    render() {
      return (
        <I18nextProvider i18n={i18n}>
            <Provider store={store}>
                <Router>
                    <LocationWatcher>
                        <AppContent />
                    </LocationWatcher>
                </Router>
            </Provider>
        </I18nextProvider>
      );
    }
}




export default App;



// WEBPACK FOOTER //
// ./src/App.js